import React from 'react';
import Footer from '../components/Footer';
import { motion } from 'framer-motion';

const SpeechLanguageTherapy = () => {
  return (
    <>
      <div className='p-5 lg:p-12 bg-waves bg-cover lg:px-36 min-h-screen space-y-3 lg:grid grid-cols-2'>
        <div>
          <motion.div
            animate={{ x: 0 }}
            initial={{ x: -500 }}
            transition={{ delay: 0.1 }}
          >
            <h3 className='text-black mb-4 text-4xl font-bold lg:text-left md:text-center lg:pl-12'>
              Speech Language Pathology (SLP)
            </h3>
          </motion.div>
          <div className='lg:py-4 lg:pr-12'>
            <div className='bg-white p-6 rounded-lg shadow-lg text-left flex'>
              <p className='text-black sm:text-justify md:text-xl'>
                Custom tailored to students with autism, ADHD, global speech and
                development delays and other communication deficiencies, our
                certified speech language pathologists work intensely with your
                child and your family to accelerate the progression of the
                student’s speech fundamentals towards appropriate baseline
                levels and beyond. Our Speech Language Pathologists (SLPs) are
                fully certified with the Alberta College of Speech Language
                Pathologist and Audiologists (ACSLPA) and with Speech Language
                and Audiology Canada (SAC). Our SLPs use their wealth of
                experience working with children of all ages and language
                concerns and are specially trained to work with ASD clients,
                having specialized training from the SCERTS, Alert and Hansen
                programs. Our speech therapists also offer holistic speech
                assessments to determine the severity of children’s disabilities
                and customize every aspect of the delivery of the speech
                language pathology program to suit your child’s specific needs.
                Both FSCD vendor direct pay and private pay options are
                available.
              </p>
            </div>
          </div>
        </div>
        <div className='lg:pr-12'>
          <img
            className='sm:mx-auto h-auto rounded-3xl drop-shadow-2xl 2xl:mt-9 lg:mt-24'
            src='/speechtherapy.png'
            alt=''
          />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SpeechLanguageTherapy;
